import React from 'react'

import { Formik, Field } from 'formik'

import { Form, Modal, Col, Button } from '_zari/core'

import { AfectacionesCompraConstant } from 'constants/index'

import { IdGen, ZrSwal } from 'utils'

const ImporteRetencionRH = ({ show, handleClose, dispatch, cuentasRetencionPercepcion }) => {
  const formInitialValues = React.useMemo(() => {
    return {
      importe: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    async data => {
      if (!cuentasRetencionPercepcion || !cuentasRetencionPercepcion.cuentaContableRetencionRH) {
        ZrSwal.showAlert({
          tipo: 'error',
          mensaje: 'La compañía no cuenta con configuración para retención. El asiento no cuadrará correctamente.'
        })
        return
      }

      dispatch({
        type: 'agregar',
        payload: {
          __keyCuentaContable: IdGen.newId(),
          _idCentroCosto: '',
          _idActivoFijo: '',
          tipoMovimientoActivo: '',
          centroCostoInfo: '',
          cuentaContable: cuentasRetencionPercepcion.cuentaContableRetencionRH || '',
          cuentaContableInfo: cuentasRetencionPercepcion.infoCuentaContableRetencionRH || '',
          importe: data.importe * -1,
          flagCentroCosto: false,
          esCuentaActivoFijo: false,
          tipoAfectacion: AfectacionesCompraConstant.RECIBO_HONORARIOS,
          noIncluyeIgv: true
        }
      })

      handleClose()
    },
    [cuentasRetencionPercepcion, dispatch, handleClose]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>IMPORTE RETENCION</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Form>
            <Modal.Body>
              <Form.Group>
                <Form.Label md={4} text='IMPORTE' alignRightAt='md' />
                <Col md={8}>
                  <Field name='importe'>
                    {({ field }) => (
                      <Form.InputNumber
                        {...field}
                        id='number-importeRetencionRH'
                        isInvalid={errors.importe && touched.importe}
                        disabled={isSubmitting}
                      />
                    )}
                  </Field>
                </Col>
              </Form.Group>
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Procesar</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(ImporteRetencionRH)
